import { combineReducers } from 'redux';
import me from 'modules/me-module';
import organization from 'modules/organization-module';
import identity from 'modules/identity-module';
import ui from 'modules/ui-module';
import social from 'modules/social-module';
import billing from 'modules/billing-module';
import tfa from 'modules/tfa-module';
import devices from 'modules/devices-module';
import extAdmin from 'modules/extadmin-module';
import mtgService from 'modules/meeting-module';
import personalAccessToken from "modules/personal-access-token-module";
import recoveryPhoneNumber from "modules/recovery-phone-number-module";

// eslint-disable-next-line no-shadow
export const makeRootReducerFactory = ({
  combineReducers,
  me,
  organization,
  identity,
  social,
  ui,
  billing,
  tfa,
  devices,
  extAdmin,
  mtgService,
  personalAccessToken,
  recoveryPhoneNumber
}) =>
  (asyncReducers) => combineReducers({
    // Add sync reducers here
    me,
    organization,
    identity,
    social,
    ui,
    billing,
    tfa,
    devices,
    extAdmin,
    mtgService,
    personalAccessToken,
    recoveryPhoneNumber,
    ...asyncReducers,
  });

export const makeRootReducer = makeRootReducerFactory({
  combineReducers,
  me,
  organization,
  identity,
  social,
  ui,
  billing,
  tfa,
  devices,
  extAdmin,
  mtgService,
  personalAccessToken,
  recoveryPhoneNumber,
});

export default makeRootReducer;
